<template>
  <div class="Footer cadfm-flexitem-fixed">
    <b-navbar class="footbar-nav" toggleable="md" :type="s_skinVariant" :variant="s_skinVariant">




            <b-col  md="4" >
              <Alerts :lang="lang.Alerts"></Alerts>
            </b-col>
            <b-col  md="4" >
              <Loader :lang="lang.Loader"></Loader>
            </b-col>
            <b-col  md="2">
              <!-- <Notifications :lang="lang.Notifications"></Notifications> -->
              <b-badge v-show="isPlugin" variant="gray">Plugin</b-badge>
              <b-badge v-show="isAgent" variant="gray">Agent <b-badge @click="goto" v-if="needUpdate" variant="danger">new</b-badge></b-badge>
              <b-badge v-show="!isAgent && !isPlugin" variant="gray">WWW</b-badge>
            </b-col>
            <b-col  md="2" >
              <LivePanelComponent v-if="isAgent||isPlugin" :lang="lang.LivePanel"></LivePanelComponent>
            </b-col>

            <div id="drawing" style="width:400px; height:400px; display:block; position:absolute; top:-9999px;"></div>




    </b-navbar>
  </div>
</template>
<script>
import Alerts from "@/components/Footer/Alerts"
import Loader from "@/components/Footer/Loader"
import LivePanelComponent from "@/components/shared/LivePanelComponent"
// import Notifications from "@/components/Footer/Notifications"

import { mapGetters } from 'vuex'

export default {
  name: 'Footer',
  components: {
    Alerts,
    Loader,
    LivePanelComponent
    // Notifications
  },
  props: {
    lang: Object
  },
  data() {
    return {
      buildObject: {
        build: "",
        buildAgentUpdate: null
      },
      agentBuild: ""
    }
  },
  computed: {
    ...mapGetters([
      'isLogged',
      'isSettings',
      's_skinVariant',
      'isAgent',
      "isPlugin",
      'appConf',
    ]),
    needUpdate() {
      if (this.agentBuild == "unavailable") {
        return false;
      }
      let temp = this.agentBuild.split(" / ");

      if (this.buildObject.buildAgentUpdate == null) {
        return false;
      }
      if (temp[0] == this.buildObject.buildAgentUpdate) {
        return false;
      }
      return true;
    }
  },
  created() {
    this.getBuild();
    this.getAgentInfo();

  },
  watch: {
    isLogged: function (newVal) {
      
      if (newVal == 1) {
        this.getAgentInfo();
      }
      
      
    },
    isAgent: function () {
      this.getBuild();
    }
  },
  methods: {
    getBuild() {

      let vue = this;
      if (this.isAgent) {
        this.$store.dispatch("s_checkAgentVersion")
          .then((result) => {

            console.log(result)
            vue.agentBuild = result;

          })
          .catch((reason) => {

            console.log("Error:", reason)
            vue.agentBuild = "unavailable";
          })
      } else {
        vue.agentBuild = "unavailable";
      }


    },
    getAgentInfo() {

      let vue = this;

      this.$store.dispatch("getAgentInfo")
        .then((result) => {

          console.log(result.data)

          if (result.status == "OK") {
            vue.buildObject.build = result.data.build;
            vue.buildObject.buildAgentUpdate = result.data.buildAgentUpdate

            let obj = {
              build: result.data.build,
              buildAgentUpdate: result.data.buildAgentUpdate
            }

            vue.$store.commit('S_BUILD', obj);
          } else {
            vue.buildObject.buildAgentUpdate = null;
          }


        }, function (reason) {

          console.log(reason);

        })

    },
    goto() {

      let to = "/About/Main";
      const query = {
        from: this.$route.path,
        to: to,
        guery: {}
      }

      this.$router.push({ path: to, query: query });
    }
  }
}
</script>
<style lang="scss">
@import "./../../scss/_theme.scss";
  .Footer{
    .footbar-nav{
      min-height: 45px !important;
    }
    .alert{
      margin: 2px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer/Footer.vue